module.exports = __webpack_public_path__ + "img/logo1.dbe6e5ab.png";